// extracted by mini-css-extract-plugin
export default {"CardPatologia":"CardPatologia_CardPatologia__h7Ahc","iconLink":"CardPatologia_iconLink__IvXwN","lined":"CardPatologia_lined__qHdhI","link":"CardPatologia_link__Yjoaf"};